import { Component, type ErrorInfo, type ReactNode } from "react";

/**
 * 全局错误边界。
 * 单个页面渲染出错时只替换该页面的内容，
 * 不再让 React 把整个后台（含侧栏）卸载成白屏。
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[ui] 页面渲染异常:", error, info.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
          background: "#f6f6f7",
          fontFamily: "system-ui, -apple-system, sans-serif",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 460,
            background: "#fff",
            border: "1px solid rgb(0 0 0 / .08)",
            borderRadius: 12,
            padding: 28,
            textAlign: "center",
          }}
        >
          <div style={{ fontSize: 15, fontWeight: 600, color: "#111" }}>页面加载失败</div>
          <p style={{ margin: "8px 0 0", fontSize: 13, lineHeight: 1.65, color: "rgb(0 0 0 / .55)" }}>
            这个页面遇到了一个错误。其他页面不受影响，可以点击下方按钮重新加载。
          </p>
          <pre
            style={{
              margin: "14px 0 0",
              padding: "10px 12px",
              borderRadius: 8,
              background: "rgb(0 0 0 / .04)",
              fontSize: 12,
              lineHeight: 1.6,
              color: "rgb(0 0 0 / .6)",
              textAlign: "left",
              overflowX: "auto",
              whiteSpace: "pre-wrap",
              fontFamily: "monospace",
            }}
          >
            {error.message}
          </pre>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              marginTop: 18,
              height: 36,
              padding: "0 18px",
              border: "none",
              borderRadius: 8,
              background: "#1677ff",
              color: "#fff",
              fontSize: 13,
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            重新加载
          </button>
        </div>
      </div>
    );
  }
}
